var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.296648C5.37075 0.296648 0 5.6719 0 12.2966C0 17.6014 3.438 22.0976 8.20275 23.6839C8.805 23.7971 9.0225 23.4259 9.0225 23.1049C9.0225 22.8199 9.01575 22.0661 9.01125 21.0656C5.6715 21.7886 4.968 19.4524 4.968 19.4524C4.42125 18.0694 3.63225 17.6981 3.63225 17.6981C2.54625 16.9564 3.7185 16.9721 3.7185 16.9721C4.9215 17.0539 5.5545 18.2059 5.5545 18.2059C6.62475 20.0419 8.3625 19.5109 9.05025 19.2019C9.15525 18.4286 9.468 17.8969 9.8085 17.6006C7.1445 17.2999 4.34325 16.2686 4.34325 11.6704C4.34325 10.3571 4.80825 9.28765 5.577 8.44765C5.44425 8.1469 5.03775 6.9244 5.68275 5.2714C5.68275 5.2714 6.687 4.95115 8.98275 6.50215C9.96062 6.23586 10.9693 6.09944 11.9828 6.0964C13.0028 6.10315 14.022 6.23665 14.9827 6.50215C17.265 4.95115 18.2685 5.2714 18.2685 5.2714C18.9127 6.9244 18.5062 8.14615 18.3892 8.44765C19.1505 9.28765 19.6155 10.3579 19.6155 11.6704C19.6155 16.2791 16.8105 17.2954 14.1435 17.5886C14.5605 17.9479 14.9512 18.6866 14.9512 19.8079C14.9512 21.4129 14.9363 22.7059 14.9363 23.0966C14.9363 23.4086 15.1462 23.7836 15.7642 23.6629C20.5642 22.0931 23.9985 17.5931 23.9985 12.2959C23.9985 5.67115 18.6277 0.295898 11.9985 0.295898L12 0.296648Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.9495e6bcbc7c3bc9e6d4edffe3512bcb.svg";
export { ForwardRef as ReactComponent };